/**
 * ErrorBoundaries
 */
export const LOG_BOUNDARY_ERROR = 'LOG_BOUNDARY_ERROR';
export const CLEAR_BOUNDARY_ERROR = 'CLEAR_BOUNDARY_ERROR';
